export default __webpack_public_path__ + "static/badge-g2-winter-2025-e9d4a519447cf56ea3111d59c2ee8063.svg";